export enum Routes {
    home = 'home',
    contact = 'contact',
    oil_finder = 'oil-finder',
    qr_overview = 'qrcode',
    sheet_overview = 'sheet',
    fluid_finder = 'fluid-finder',
    not_found = 'not-found',
}
